const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/defs/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        hostpital: 'Demospital',
        datenschutz: 'Datenschutz',
        disclaimer: 'Disclaimer',
        impressum: 'Impressum',
    },
    __RELATIVE_SOURCE_FILE__
);
